import { render, staticRenderFns } from "./leftPanel.vue?vue&type=template&id=8efd4ae4&scoped=true"
import script from "./leftPanel.vue?vue&type=script&lang=js"
export * from "./leftPanel.vue?vue&type=script&lang=js"
import style0 from "./leftPanel.vue?vue&type=style&index=0&id=8efd4ae4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efd4ae4",
  null
  
)

export default component.exports